export default "__VITE_ASSET__D0w4x4ZX__"